import {
  Badge,
  Breadcrumb,
  Button,
  Calendar,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Drawer,
  Dropdown,
  Flex,
  Form,
  Input,
  Layout,
  notification,
  Radio,
  Row,
  Select,
  Space,
  Table,
  Tag,
  theme,
} from "antd";
import {
  SendOutlined,
  MoreOutlined,
  MessageOutlined,
  UnlockOutlined,
  EyeOutlined,
  LockOutlined,
  EditOutlined,
} from "@ant-design/icons";
import React, { useEffect, useRef, useState } from "react";
import TextArea from "antd/es/input/TextArea";
import MeetingAPI from "../../../restAPI/MeetingAPI";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import moment from "moment-timezone";
import useCurrentCompany from "../../../hooks/useCurrentCompany";

const { Search } = Input;
const { Header, Sider, Content } = Layout;

const options = [
  {
    label: "Yes",
    value: "yes",
  },
  {
    label: "No",
    value: "no",
  },
  {
    label: "May Be",
    value: "maybe",
  },
];
export default function MyResponse(props) {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const { companyId, token, userCompany } = useSelector((state) => state.auth);

  const [isSignatoryChecked, setIsSignatoryChecked] = useState(
    props.actionStep !== "add"
      ? props.meetingFullData.participant.member.signatoryStatus
      : false
  );
  const [value, setValue] = useState("");
  const [isSearchingALTsignatoty, setIsSearchingALTsignatoty] = useState(false);
  const [showTextArea, setShowTextArea] = useState(false);
  const [altSignatoryDetails, setAltSignatoryDetails] = useState(null);  
  const currentCompanyInfo = useCurrentCompany();
  const [rsvpResponse, setRsvpResponse] = useState({
    type: "",
    altSignatory: false,
    comment: "",
  });
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, message, description, placement) => {
    api[type]({
      message: message,
      description: description,
      placement,
    });
  };

  useEffect(() => {
    if (props.actionStep !== "add") {
      setShowTextArea(props.meetingFullData.participant.member.signatoryStatus);
      form.setFieldsValue({
        comment: props.meetingFullData.participant.member.comment,
      });
    }
  }, [props.actionStep]);

  

  useEffect(() => {
    setValue(
      props.actionStep === "add" ? "" : props.attendanceStatus?.toLowerCase()
    );
    if (props.actionStep === "add") {
      setShowTextArea(false);
      form.resetFields();
      setRsvpResponse((prev) => ({
        ...prev,
        type: "",
        altSignatory: false,
        comment: "",
      }));
    }
  }, [props.meetingDate]);

  useEffect(() => {
    if (props.actionStep === "add") {
      setShowTextArea(false);
      form.resetFields(["comment"]);
      setRsvpResponse((prev) => ({
        ...prev,
        altSignatory: false,
        comment: "",
      }));
    }
  }, [value]);

  const getAvailableSignatory = async () => {
    const {
      _id: meetingId,
      info: { startDate, endDate },
      originalDate,
    } = props.meetingFullData;

    const newPayload = {
      userId: currentCompanyInfo.userDetailsId,
      meetingsDetails: [
        {
          meetingId: meetingId,
          meetingStartDateTime: startDate,
          meetingEndDateTime: endDate,
          meetingOriginalDate: originalDate,
        },
      ],
    };

    try {
      setIsSearchingALTsignatoty(true);
      const res = await MeetingAPI.getAvailableSignatory(
        newPayload,
        companyId,
        token
      );
      setAltSignatoryDetails(res.data || []);
    } catch (error) {
      console.log("Error in getAvailable singnatory :", error);
      openNotificationWithIcon(
        "error",
        "Failed",
        `Failed to get alternative signatory details.`,
        "bottomLeft"
      );
    } finally {
      setIsSearchingALTsignatoty(false);
    }
  };

  const handleSubmit = async () => {
    if (rsvpResponse.type.length === 0) {
      openNotificationWithIcon(
        "error",
        "Response adding failed",
        `Please select an response before submit.`,
        "bottomLeft"
      );
      return;
    }

    const {
      _id: meetingId,
      info: { startDate, endDate, name: meetingName },
      originalDate,
      participant: { member, _id: participantId },
      committeeId,
    } = props.meetingFullData;

    if (member.type !== "signatory") {
      //
      let transformedResponse = {
        rsvp: {
          type: rsvpResponse.type || "yes",
          signatory: rsvpResponse.altSignatory || false,
          comment: rsvpResponse.comment || "",
        },
      };

      if (rsvpResponse.type === "no" && rsvpResponse.altSignatory) {
        transformedResponse = {
          ...transformedResponse,
          details: [
            {
              meetingId: meetingId || "",
              meetingName: meetingName || "",
              meetingOriginalDate: originalDate || "",
              meetingDate: dayjs(props.meetingDate).toISOString() || "",
              meetingStartDateTime: startDate || "",
              meetingEndDateTime: endDate || "",
              committeeId: committeeId || "",
              signatoryId: altSignatoryDetails[0]?.signatoryId || "",
            },
          ],
        };
      }

      try {
        const response = await MeetingAPI.updateParticipantRsvpById(
          participantId,
          transformedResponse,
          companyId,
          token
        );

        if (response.status === 200) {
          openNotificationWithIcon(
            "success",
            "Successful",
            `${response.data.message}`,
            "bottomLeft"
          );
          props.getMeetingsByDate();
          if (value !== "no") {
            setShowTextArea(false);
            setIsSignatoryChecked(false);
            form.resetFields();
            setRsvpResponse((prev) => ({
              ...prev,
              type: "",
              altSignatory: false,
              comment: "",
            }));
          }
          // setRsvpResponse(prev => ({ ...prev, type: '', }))
        } else {
          openNotificationWithIcon(
            "error",
            "Response adding failed",
            `${response.data.message}`,
            "bottomLeft"
          );
        }
      } catch (error) {
        console.log("Error in rsvp submission :", error);
      }
    } else {
      openNotificationWithIcon(
        "error",
        "Response adding failed",
        `Signatory can't change RSVP.`,
        "bottomLeft"
      );
    }
  };

  const handleResponseChange = (e) => {
    const checkDateToHandleClick = moment(
      props.meetingFullData.info.startDate
    ).isSameOrAfter(moment().startOf("day"), "minutes");
    if (!checkDateToHandleClick) {
      openNotificationWithIcon(
        "error",
        "Meeting edit failed",
        `You can't edit previous meetings.`,
        "bottomLeft"
      );
      return;
    }

    const newValue = e.target.value;
    setValue(newValue);
    setRsvpResponse((prev) => ({
      ...prev,
      type: newValue,
    }));

    setRsvpResponse((prev) => ({
      ...prev,
      type: newValue,
      altSignatory: false,
      comment: newValue !== "no" ? "" : prev.comment,
    }));
  };

  return (
    <>
      <Form form={form}>
        <Form.Item name="rsvpResponse">
          <center>
            <Radio.Group
              options={options}
              onChange={(e) => {
                handleResponseChange(e);
              }}
              value={value}
              optionType="button"
              disabled={
                props.meetingFullData?.participant?.member?.attendance ===
                "mandatory"
              }
            />
          </center>
        </Form.Item>
        {value === "no" && (
          <Form.Item name="signatory">
            <Checkbox
              checked={isSignatoryChecked}
              onChange={(e) => {
                const checked = e.target.checked;
                setIsSignatoryChecked(checked);

                setShowTextArea(checked);
                if (checked) {
                  getAvailableSignatory();
                }
                if (!checked) {
                  form.resetFields(["comment"]);
                }

                setRsvpResponse((prev) => ({
                  ...prev,
                  altSignatory: checked,
                }));
              }}
              disabled={
                props.actionStep === "edit" &&
                props.attendanceStatus?.toLowerCase() === "no"
              }
            >
              Alternative Signatory
            </Checkbox>
          </Form.Item>
        )}
        {showTextArea && value === "no" && (
          <>
            <Form.Item name="signatoryName">
              <Content>
                <span>
                  {props.actionStep === "add" ||
                  props.attendanceStatus?.toLowerCase() !== "no"
                    ? "Most available signatory "
                    : "Selected signatory "}
                </span>
                <br />
                <span>
                  {props.actionStep === "add" ||
                  props.attendanceStatus?.toLowerCase() !== "no"
                    ? isSearchingALTsignatoty
                      ? "Searching..."
                      : altSignatoryDetails && altSignatoryDetails.length > 0
                      ? altSignatoryDetails[0].signatoryName
                      : "No available signatory"
                    : props.meetingFullData.participant?.member
                        ?.signatoryName || "Not selected"}
                </span>
              </Content>
            </Form.Item>
            <Form.Item name="comment">
              <TextArea
                placeholder="Add your Note"
                onChange={(e) => {
                  setRsvpResponse((prev) => ({
                    ...prev,
                    comment: e.target.value,
                  }));
                }}
              />
            </Form.Item>
          </>
        )}
        <Form.Item>
          <Button
            type="primary"
            block
            onClick={handleSubmit}
            disabled={
              rsvpResponse.type.length === 0 ||
              value === props.attendanceStatus?.toLowerCase() ||
              (value === "no" &&
                isSignatoryChecked &&
                altSignatoryDetails &&
                altSignatoryDetails.length === 0)
            }
          >
            Send
          </Button>
        </Form.Item>
      </Form>
      {contextHolder}
    </>
  );
}
